<template>
  <ul>
    <leave-list-item
      v-bind="$props"
      :student="item"
      v-for="(item, index) in list"
      :key="`${item.leaveId}-${item.personId}`"
      @click="handlerClickItem"
      @clickBack="handlerClickBack"
      :showbb="showbb && index < list.length - 1"
    ></leave-list-item>
  </ul>
</template>

<script>
import mixin from '@/mixin'
import leaveListItem from './leaveListItem'

export default {
  mixins: [mixin],
  name: 'leaveList',
  components: { leaveListItem },
  props: {
    list: Array,
    biz: {
      type: String,
      default: 'list'
    },
    // 2: 修改或撤销请假列表
    type: {
      type: Number,
      default: 1
    },
    noPb: {
      type: Boolean,
      default: false
    },
    noPbCross: {
      type: Boolean,
      default: false
    },
    showbb: {
      type: Boolean,
      default: false
    },
    hasTag: {
      type: Boolean,
      default: false
    },
    noTime: {
      type: Boolean,
      default: false
    },
    noType: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  async mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    handlerClickItem(student) {
      this.$emit('click', student)
    },
    handlerClickBack(url, studentDingIds, leaveId) {
      this.$emit('clickBack', url, studentDingIds, leaveId)
    }
  }
}
</script>

<style lang="scss" scoped></style>
